export const socialAnalytics = {
  page: {
    title: 'Métricas de LinkedIn',
    subtitle:
      'Cómo performó tu equipo en LinkedIn, hayan salido los posts desde Referent o a mano, y quién genera tracción.',
    disclosure:
      'Los posts publicados a mano se toman de cada cuenta conectada, así que pueden tardar unas horas en aparecer. LinkedIn no reporta impresiones en todos los posts, así que cualquier número con subrayado punteado cubre una parte del período. El alcance único, los guardados y las visitas al perfil no están disponibles en la API: la columna Alcance cuenta impresiones.',
    lastSync: {
      fresh: 'Métricas actualizadas por última vez el {{date}}.',
      never: 'Todavía no se sincronizaron las métricas.',
      stale:
        'Las métricas no se actualizan desde el {{date}}, hace más de {{hours}} horas. Lo más probable es que el sync esté roto: estos números no se quedaron quietos solos.',
    },
  },

  loadError: 'No se pudieron cargar las métricas.',
  retry: 'Reintentar',

  tabs: {
    competition: 'Competencia',
    overTime: 'Evolución',
    bestPosts: 'Mejores posts',
  },

  dateRange: {
    label: 'Rango de fechas',
    trigger: '{{from}} - {{to}}',
    presetsLabel: 'Atajos',
    presets: {
      thisWeek: 'Esta semana',
      last14Days: 'Últimos 14 días',
      last30Days: 'Últimos 30 días',
      quarterToDate: 'Trimestre en curso',
      last3Months: 'Últimos 3 meses',
      last6Months: 'Últimos 6 meses',
      thisYear: 'Este año',
      allTime: 'Todo el período',
      custom: 'Personalizado',
    },
  },

  coverage: {
    noData: 'Sin datos',
    noDataHint: 'LinkedIn no reportó esta métrica en ningún post del período.',
    partialHint: '{{reported}} de {{published}} posts reportaron esta métrica.',
  },

  kpi: {
    publishedPosts: 'Posts publicados',
    reactions: 'Reacciones',
    comments: 'Comentarios',
    impressions: 'Impresiones',
    engagementRate: 'Tasa de engagement',
    deltaVsPrevious: '{{value}} vs. período anterior',
    ratePoints: '{{value}} pts',
    noComparison: 'Sin comparación disponible',
  },

  awaitingSync: {
    title: 'Todavía no llegaron las métricas',
    description:
      'Los posts ya se publicaron, pero todavía no se les tomó ninguna captura. Las métricas se actualizan cada {{minHours}}-{{maxHours}} horas por cuenta, así que un post recién publicado no tiene números hasta la próxima corrida.',
  },

  empty: {
    noPosts: {
      title: 'Todavía no hay posts publicados',
      description:
        'Publicá un post en LinkedIn — desde Referent o a mano — y sus métricas van a aparecer acá después del próximo sync.',
    },
    noPostsInPeriod: {
      title: 'No se publicó nada en este período',
      description: 'Hubo actividad antes de esta ventana. Ampliá el período para verla.',
    },
    notConnected: {
      title: 'Conectá tu cuenta de LinkedIn',
      description:
        'Estas métricas se leen de la cuenta de LinkedIn que conectás a Referent. Conectá la tuya y todos los posts — publicados desde Referent o a mano — van a empezar a reportar acá después del próximo sync.',
    },
    needsReconnect: {
      title: 'Tu conexión con LinkedIn dejó de funcionar',
      description:
        'Referent ya no puede leer tu cuenta de LinkedIn, así que no se está capturando nada de ella. Reconectala para retomar el sync.',
    },
  },

  posts: {
    unknownAuthor: 'Autor desconocido',
    openOnLinkedIn: 'Abrir en LinkedIn',
    reactionsBreakdownLabel: 'Reacciones por tipo',
    origin: {
      filter: {
        label: 'Origen',
        all: 'Todos',
      },
      referent: {
        label: 'Referent',
        hint: 'Publicado desde Referent.',
      },
      external: {
        label: 'Fuera de Referent',
        hint: 'Publicado a mano en LinkedIn y detectado desde la cuenta conectada.',
      },
    },
    columns: {
      engagementRate: 'Engagement',
    },
  },

  reactions: {
    like: 'Me gusta',
    praise: 'Felicitaciones',
    appreciation: 'Apoyo',
    empathy: 'Me encanta',
    interest: 'Interesante',
    entertainment: 'Divertido',
    maybe: 'Curioso',
  },

  detail: {
    title: 'Detalle del post',
    description: 'Cómo fue acumulando engagement este post en cada captura.',
    loadError: 'No se pudo cargar el historial.',
    retry: 'Reintentar',
    metricSelectLabel: 'Métrica a graficar',
    deletedOnLinkedIn:
      'Este post ya no existe en LinkedIn (detectado el {{date}}). Se conserva su historial, pero deja de contar en los KPIs.',
    lastSyncedAt: 'Última actualización: {{date}}',
    metrics: {
      reactions: 'Reacciones',
      comments: 'Comentarios',
      reposts: 'Reposts',
      impressions: 'Impresiones',
      pageViewers: 'Visitas al perfil desde este post',
      followersGained: 'Seguidores ganados',
    },
    empty: {
      noCaptures: {
        title: 'Todavía no hay capturas',
        description:
          'Las métricas se actualizan cada {{minHours}}-{{maxHours}} horas por cuenta. A este post todavía no se le tomó ninguna captura.',
      },
      singleCapture: {
        title: 'Por ahora hay una sola captura',
        description:
          'Un gráfico necesita al menos dos capturas para mostrar movimiento. Las métricas se acumulan con los días, con una actualización cada {{minHours}}-{{maxHours}} horas por cuenta.',
      },
      thinMetric: {
        title: 'No hay suficientes capturas de esta métrica',
        description:
          'Este post tiene historial, pero esta métrica se reportó una sola vez. Elegí otra métrica o volvé después del próximo sync.',
      },
    },
  },

  competition: {
    rank: '#{{rank}}',
    scoreLabel: 'Puntaje',
    loadError: 'No se pudo cargar la tabla de posiciones.',
    rankDelta: {
      up: 'Subió {{count}} puestos respecto del período anterior',
      down: 'Bajó {{count}} puestos respecto del período anterior',
    },
    change: {
      vsPrevious: '{{value}} respecto del período anterior',
    },
    podium: {
      title: 'Podio',
      subtitle: 'Los tres mejores puntajes del período.',
      participants: '{{count}} participantes',
      emptySlot: 'Nadie alcanzó el puesto {{rank}} en este período.',
    },
    table: {
      title: 'Tabla de posiciones',
      subtitle: 'Todos los que publicaron en el período, con las métricas de las que sale su puntaje.',
      empty: 'Nadie publicó en este período.',
      total: 'Total',
      averageScore: 'Promedio',
    },
    columns: {
      rank: 'Puesto',
      collaborator: 'Colaborador',
      score: 'Puntaje',
      reach: 'Alcance',
      engagement: 'Engagement',
      posts: 'Posts',
      comments: 'Comentarios',
      followers: 'Seguidores',
    },
    empty: {
      title: 'Nadie publicó en este período',
      description:
        'La tabla se completa a medida que la gente de tu organización publica en LinkedIn. Ampliá el período para ver actividad anterior.',
    },
    scoreHelp: {
      trigger: '¿Cómo se calcula el puntaje?',
      title: 'Cómo se calcula el puntaje',
      steps: {
        normalize:
          'Cada métrica se lleva a una escala de 0 a 100 contra el mejor y el peor del período (min-max).',
        weight: 'Cada dimensión pesa lo suyo:',
        total: 'La suma ponderada, redondeada, es el puntaje de 0 a 100.',
      },
      dimensions: {
        impressions: 'Alcance',
        reactions: 'Reacciones',
        followersGained: 'Seguidores ganados',
        posts: 'Posts',
        comments: 'Comentarios',
      },
      engagementNote: 'La tasa de engagement no puntúa: se muestra solo como referencia.',
      relativeNote:
        'El puntaje es relativo al período: cambiar el rango de fechas recalcula toda la tabla.',
    },
  },

  overTime: {
    loadError: 'No se pudo cargar la evolución del período.',
    bucket: {
      weekOf: 'Semana del {{date}}',
    },
    gap: {
      noPosts: 'No se publicó nada',
      notReported: 'Ningún post reportó esta métrica',
    },
    seriesNote: {
      daily:
        'Cada punto suma lo que acumularon los posts publicados ese día — no las interacciones que ocurrieron ese día.',
      weekly:
        'Cada punto suma lo que acumularon los posts publicados esa semana — no las interacciones que ocurrieron esa semana.',
    },
    gapNote:
      'Un corte en la línea no es un cero: significa que ningún post reportó esa métrica en ese tramo. Los posts publicados son la excepción — los cuenta Referent, así que ahí un cero sí quiere decir que no salió nada.',
    empty: {
      title: 'No hay nada para graficar en este período',
      description: 'Ampliá el rango de fechas y la evolución del período aparece acá.',
    },
  },

  bestPosts: {
    noText: 'Post sin texto',
    loadError: 'No se pudo cargar el ranking de posts.',
    empty: {
      title: 'No hay posts para rankear en este período',
      description:
        'El ranking se completa a medida que tu equipo publica en LinkedIn. Ampliá el período para ver actividad anterior.',
    },
    podium: {
      title: 'Mejores posts',
      subtitle: 'Los tres posts con mejor puntaje del período.',
      emptySlot: 'Ningún post alcanzó el puesto {{rank}} en este período.',
      openPost: 'Abrir en LinkedIn el post #{{rank}}, de {{author}}',
    },
    table: {
      title: 'Ranking de posts',
      subtitle: 'Todos los posts del período, puntuados contra el mejor del conjunto.',
      empty: 'No se publicó ningún post en este período.',
      emptyForOrigin: 'No se publicó ningún post de este origen en el período.',
      truncated:
        'El ranking abarca los {{shown}} posts con mejor puntaje del período, de {{total}} publicados.',
      originNote:
        'Filtrar por origen solo esconde filas: el puesto y el puntaje siguen siendo los del período completo.',
      openDetail: 'Ver el detalle del post de {{author}}',
    },
    columns: {
      rank: 'Puesto',
      author: 'Autor',
      score: 'Puntaje',
      content: 'Contenido',
      impressions: 'Impresiones',
      reactions: 'Reacciones',
      comments: 'Comentarios',
      reposts: 'Reposts',
      publishedAt: 'Publicado',
      actions: 'Acciones',
    },
  },
} as const
